/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { isEmpty, selectedStoryTemplate, selectedStoryTemplateSettings } from "../isomorphic/utils";
import get from "lodash/get";

export function getUpdatedStoryConfig({
  config,
  relatedStories,
  templateConfig,
  storyPageType,
  storyStoreField,
  story,
  enableDarkMode,
}) {
  const premiumStoryIconConfig = get(config, ["pagebuilder-config", "general", "rows", "premiumStoryIcon"], {});

  const timeFormat = get(config, ["pagebuilder-config", "general", "timeFormat"], "12hours");
  const getVisualStoryConfig = get(config, ["pagebuilder-config", "story", "text-story"], {});
  const getStoryConfig = get(config, ["pagebuilder-config", storyStoreField, storyPageType], {});
  const pbStoryConfig = story["story-template"] === "visual-story" ? getVisualStoryConfig : getStoryConfig;

  const storyTemplateSettings = selectedStoryTemplateSettings(storyPageType, config, storyStoreField);

  const defaultTemplateConfig = getDefaultTemplateConfig({
    config,
    relatedStories,
    story,
    pbStoryConfig,
    timeFormat,
    storyPageType,
    storyStoreField,
    enableDarkMode
  });
  const updatedConfig = { ...defaultTemplateConfig, ...templateConfig, ...storyTemplateSettings };
  const storyConfig = !isEmpty(pbStoryConfig) ? updatedConfig : defaultTemplateConfig;
  const { enableLocalization = false, localizedElements = {} } = get(
    config,
    ["pagebuilder-config", "general", "localization"],
    {}
  );

  const localizedElementData = enableLocalization ? localizedElements : {};
  const {
    months: localizedMonths,
    meridiem: localizedMeridiem,
    publishTime: localizedPublishTime,
    buttonLabels = {},
  } = localizedElementData;
  const {
    publishedOn: localizedPublishedOn,
    updatedOn: localizedUpdatedOn,
    timeToRead: localizedTimeToRead,
    keyEvents: localizedKeyEvents,
  } = buttonLabels;

  return {
    ...storyConfig,
    premiumStoryIconConfig,
    publishedDetails: {
      ...storyConfig.publishedDetails,
      localizedPublishedOn,
      localizedUpdatedOn,
      localizedTimeToRead,
      localizedMonths,
      localizedMeridiem,
      localizedPublishTime,
      timeFormat,
      localizedKeyEvents,
    },
  };
}

function getDefaultTemplateConfig({
  config,
  story,
  storyPageType,
  storyStoreField,
  pbStoryConfig,
  relatedStories,
  timeFormat,
  enableDarkMode
}) {
  const storyTemplate = selectedStoryTemplate(storyPageType, config, storyStoreField);
  const isStoryInfiniteScrollEnabled =
    get(
      config,
      ["pagebuilder-config", "infiniteScroll", "infiniteScrollType"],
      get(config, ["themeAttributes", "infinite-scroll"], "disabled")
    ) !== "disabled";

  const showAllCards = -1;
  const { asideSlots, "story-slots": storySlots = {} } = pbStoryConfig;

  const { darkTheme = "#1d1d1d", theme = "" } = get(pbStoryConfig, ["settings"], {});
  return {
    theme: enableDarkMode ? "#1d1d1d" : "",
    verticalShare: "",
    shareIconType: "plain-svg",
    templateType: storyTemplate,
    noOfVisibleCards: showAllCards,
    showSectionTag: true,
    publishedDetails: {
      enablePublishedTime: true,
      enableUpdatedTime: false,
      showReadTime: false,
      timeFormat,
    },
    storySlots,
    asideCollection: {
      data: relatedStories,
      slots: asideSlots || [
        {
          type: "ad",
          layout: "Story-Mrec",
          layoutLabel: "Story-Mrec",
          config: {
            targetingId: "story-mrec-aside-collections",
          },
        },
        {
          type: "collection",
        },
      ],
      config: {
        title: "Related Stories",
        theme: enableDarkMode ? darkTheme : theme,
        collectionNameBorderColor: enableDarkMode ? "#ffffff" : "#000",
        showAuthor: true,
        showTime: true,
        showReadTime: false,
        mountAtPrefix: get(config, ["mountAt"], ""),
      },
    },
    authorDetails: { template: "default", opts: { hideBio: true, hideImage: false } },
    premiumStoryIconConfig: {
      premiumIconColor: "#F7B500",
      premiumIconStyle: "star",
      enablePremiumStoryIcon: false,
    },
    isStoryInfiniteScrollEnabled,
  };
}
